
            const globalValue = window.jQuery;
            export default globalValue;
            export { globalValue };
          